/* eslint-disable jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import BN from 'bignumber.js';
import cn from 'classnames';
// TODO: move to utils
import { getDuration } from '../../../../../components/util';
import { formatToken, fromWeiToEther } from '../../../../../helpers/token-helper';
import { TOKEN_OPTIONS, RAZE_ETH_UNI } from '../../../../../constants/blockchain-constants';
import s from '../item.module.scss';
import { useGetTheme } from '../../../../../hooks/useGetTheme';
import {
  ColumnTotalStakedAmount,
  ColumnStatus,
  ColumnEstimatedApr,
  ColumnEstimatedDailyRewards,
  ColumnEarnedRewards,
} from '../../../../../components/Stake/column';

const RazeEthUniItem = ({ isActive, onClick }) => {
  const colors = useGetTheme();

  const {
    stakeBalance,
    rewardEarned,
    rewardBalance,
    percentInOM,
    // percentFromUniSwap,
    estimatedDailyReward,
  } = useSelector((state) => state.RAZEETHUNIstake.stake);

  const getWrapBgColor = () => ({ style: { backgroundColor: colors.listAssetBackground } });

  const subIcons = [
    {
      src: colors.icons.unicorn,
      href: 'https://app.uniswap.org/#/add/v2/ETH/0x5Eaa69B29f99C84Fe5dE8200340b4e9b4Ab38EaC',
    },
  ];

  const percentInOMText = `${percentInOM}%`;

  return (
    <div className={cn(s.wrap, { [s.active]: isActive })} {...getWrapBgColor()} onClick={onClick}>
      <ColumnTotalStakedAmount
        title={TOKEN_OPTIONS[RAZE_ETH_UNI].title}
        logoIcon={TOKEN_OPTIONS[RAZE_ETH_UNI].icon}
        token={formatToken(stakeBalance, 10)}
        subIcons={subIcons}
      />
      <ColumnStatus stakeDuration={getDuration(fromWeiToEther(stakeBalance))} />
      <ColumnEstimatedApr percentInOMText={percentInOMText} />
      <ColumnEstimatedDailyRewards
        titleRewardToken={TOKEN_OPTIONS[RAZE_ETH_UNI].titleRewardToken}
        estimatedDailyReward={estimatedDailyReward}
      />
      <ColumnEarnedRewards
        rewardEarned={formatToken(new BN(rewardEarned).plus(rewardBalance).toString(10))}
        titleRewardToken={TOKEN_OPTIONS[RAZE_ETH_UNI].titleRewardToken}
      />
    </div>
  );
};

RazeEthUniItem.propTypes = {
  isActive: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default RazeEthUniItem;
